import React from "react";
import moment from "moment";
import moment_tz from "moment-timezone";
import "moment/locale/es";

interface DateFormatProps {
    date?: Date
    format?: string
    zone?: boolean
}

export default function DateFormat(props: DateFormatProps) {
    return (
        <span>{formatDate(props.date, props.format, props.zone)}</span>
    );
}

export function formatDate(date?: Date, format?: string, zone?:boolean) {
    moment.locale("es");

    if (date) {
        return moment(date).format(format || "llll") + (zone ? moment_tz().tz(moment_tz.tz.guess(true)).format(' z [(GMT]Z[)]').replace(/0|:/g, "") : "");
    }
    return "---"
}
